export const API = 'API';
export const API_START = 'API_START';
export const API_END = 'API_END';
export const ACCESS_DENIED = 'ACCESS_DENIED';
export const API_ERROR = 'API_ERROR';

export const apiStart = (label, showLoading) => ({
  type: API_START,
  payload: label,
  showLoading,
});

export const apiEnd = (label) => ({
  type: API_END,
  payload: label,
});

export const accessDenied = (url) => ({
  type: ACCESS_DENIED,
  payload: {
    url,
  },
});

export const apiError = (error, label) => ({
  type: API_ERROR,
  payload: label,
  error,
});

export const apiAction = ({
  url = '',
  method = 'GET',
  data = null,
  accessToken = null,
  onSuccess,
  onFailure,
  label = '',
  headersOverride = null,
  showLoading,
  formData = null
}) => {
  return {
    type: API,
    payload: {
      url,
      method,
      data,
      accessToken,
      onSuccess,
      onFailure,
      label,
      headersOverride,
      showLoading,
      formData
    },
  };
};

const initialState = {
  isLoadingData: false,
  action: null,
};

export const api = (state = initialState, action) => {
  switch (action.type) {
    case API_START:
      return {
        ...state,
        isLoadingData: !!action.showLoading,
        action: action,
      };
    case API_END:
    case API_ERROR:
      return {
        ...state,
        isLoadingData: false,
        action: action,
      };
    default:
      return state;
  }
};
